import {initialState as general} from "../reducers/general";
import {initialState as blog} from "../reducers/blog";
import {initialState as utils} from "../reducers/utils";

const reducers = {
    general,
    blog,
    utils,
};

export default state => {
    const sData = {};
    Object.keys(reducers).forEach(selectorKey => {
        Object.keys(reducers[selectorKey]).forEach(key => {
            sData[key] = state[selectorKey][key];
        });
    });
    return sData;
};





